import React, { Component } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { IActivityAssignmentGradeModalTabsProps } from '../../../../../models/components/activity-assignment-grade-modal-tabs';

const T = Translator.create();
const _logger = Log.create('gradeAssignment-tabpanel');

export class ActivityAssignmentGradeModalTabs extends Component<IActivityAssignmentGradeModalTabsProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <ul className="nav nav-tabs border-0" style={{paddingInlineStart: '0px'}} id="tabs" role="tablist">
                {
                    <li className="nav-item">
                        <a
                            className={this.props.currentTab === '_classStudentsTab' ? 'nav-link active' : 'nav-link '}
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={() => this.props.validateTabAndChange('_classStudentsTab')}
                            id="classStudents-tab"
                        >
                            {T.t('r_tab_class_students')}
                        </a>
                    </li>
                }
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_allStudentsTab' ? 'nav-link active' : 'nav-link '}
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick={() => this.props.validateTabAndChange('_allStudentsTab')}
                        id="allStudents-tab"
                    >
                        {T.t('r_tab_all_students')}
                    </a>
                </li>
            </ul>
        );
    }
}

export default ActivityAssignmentGradeModalTabs;
